// The app's categorised logger, over the shared diagnostics logger, which
// records even in production (so it reaches a bug report) and prints only in
// development. Warnings and errors are always kept; debug, info and the auth
// and api lines only in development.

import { createLogger } from "@jkast90/kast-common/diagnostics";

const isDev = process.env.NODE_ENV === "development";

const base = createLogger({ debug: isDev });

export const logger = {
  debug: base.debug,
  info: base.debug,
  warn: base.warn,
  error: base.error,
  auth: createLogger({ category: "AUTH", debug: isDev }).debug,
  api: createLogger({ category: "API", debug: isDev }).debug,
};

export default logger;
